module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChapTitle"
  }, [_c('a', {
    attrs: {
      "id": "HLD6"
    }
  }), _vm._v("Forest Park")]), _vm._v(" "), _c('p', {
    staticClass: "mhead"
  }, [_vm._v("Fabric Requirements and Cutting")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nhead"
  }, [_vm._v("NOTE")]), _vm._v(" "), _c('p', {
    staticClass: "ntxt"
  }, [_vm._v("Most of the pieces in this block are cut using templates from "), _c('span', {
    attrs: {
      "href": "#/91_source#pg_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pattern 1")]), _vm._v(". The dimensions listed in the chart under “Size to Cut” represent the amount of fabric required for each piece. More fabric may be required for "), _c('span', {
    attrs: {
      "href": "#/89_chapter85#HLD99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("shortcut piecing")]), _vm._v(" or "), _c('span', {
    attrs: {
      "href": "#/89_chapter85#HLD102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fussy cutting")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ntxt"
  }, [_vm._v("To make a template from a pattern, refer to "), _c('span', {
    attrs: {
      "href": "#/89_chapter85#HLD101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making and Using Freezer-Paper Templates")]), _vm._v(". When cutting your fabric, remember to add seam allowances and mark points for matching seams.")]), _vm._v(" "), _c('p', {
    staticClass: "ph1"
  }, [_vm._v("Make the Block")]), _vm._v(" "), _c('p', {
    staticClass: "ph2"
  }, [_vm._v("Make the Contrasting Triangle Unit")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Sew piece B1 and piece B2 to a piece A. The unit will now be 3½˝ × 4½˝. "), _c('i', [_vm._v("figure a")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ph2"
  }, [_vm._v("Make the Triangle Units")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Sew a piece C1 and a piece C2 to a piece A. "), _c('i', [_vm._v("figure b")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Repeat Step 1 to create a total of 3 triangle units AC, each 3½˝ × 4½˝.")]), _vm._v(" "), _c('p', {
    staticClass: "ph2"
  }, [_vm._v("Finish the Block")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Arrange the 4 triangle units in 2 rows, placing the contrasting triangle unit at the top left. Sew the units in each row together. Then sew the 2 rows together.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Sew piece D to the left side of the block. "), _c('i', [_vm._v("figure c")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ph2"
  }, [_vm._v("ALTERNATE IDEAS")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12d.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12c.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e98348c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_chapter04.vue
// module id = 75
// module chunks = 0